import React, { useEffect, useState } from 'react';
import { Box, FlexControlledForm, useDebounce } from '@common-fe/common-fe';

import FormLoader from '@/modules/employer/components/SetupEmployer/FormLoader';
import { useSetupEmployerMode } from '@/modules/employer/components/SetupEmployer/hooks/useSetupEmployerMode';
import { useSetupEmployerStore } from '@/modules/employer/store/useSetupEmployer.store';

import useClaimsSettingsForm from './hooks/useClaimsSettingsForm';
import useClaimsSettingsStore from './store/useClaimsSettings.store';
import ResetButton from './ResetButton';

const ClaimsSettings = () => {
  const { loading } = useSetupEmployerStore();
  const { viewMode } = useSetupEmployerMode();
  const [currentValues, setCurrentValues] = useState({});
  const debouncedValue = useDebounce(currentValues);
  const fields = useClaimsSettingsForm(currentValues);
  const { setClaimsSettings } = useClaimsSettingsStore();
  const [lastReset, setLastReset] = useState('');
  useEffect(() => {
    setClaimsSettings(debouncedValue);
  }, [debouncedValue, setClaimsSettings]);

  if (loading) return <FormLoader testId="claims-section-loader" />;

  return (
    <Box
      data-testid="claims-section-wrapper"
      direction="row"
      justify="between"
      align="start"
      pad={{ right: 'spacing32' }}
      background="canvas"
      key={lastReset}
      round="container1Round"
      border={{ color: 'border2', size: 'small' }}
    >
      <FlexControlledForm
        editMode={!viewMode}
        showError
        fields={fields}
        onChangeValues={setCurrentValues}
        isThinMode
        wrapperStyle={{ border: 'none', paddingBottom: 0 }}
      />
      <Box margin={{ top: '34px' }}>
        <ResetButton
          viewMode={viewMode}
          currentValues={currentValues}
          setCurrentValues={(data) => {
            setCurrentValues(data);
            setLastReset(`${+new Date()}`);
          }}
        />
      </Box>
    </Box>
  );
};

export default ClaimsSettings;
